import { useCallback, useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { GrnEditor } from "@/components/inventory/GrnEditor";
import { GrnView } from "@/components/inventory/GrnView";

const STATUS = { draft: ["Draft", "bg-slate-200 text-slate-700"], posted: ["Posted", "bg-amber-100 text-amber-900"], put_away: ["Put away", "bg-emerald-100 text-emerald-800"] };
export const StatusPill = ({ s, id }) => <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${STATUS[s]?.[1] || ""}`} data-testid={id}>{STATUS[s]?.[0] || s}</span>;

export default function Grns() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => api.get("/inventory/grns").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const openGrn = async (g) => setOpen((await api.get(`/inventory/grns/${g.id}`)).data);
  const close = () => { setOpen(null); load(); };

  if (open === "new" || open?.status === "draft") return <GrnEditor grn={open === "new" ? null : open} onClose={close} onPosted={(g) => { setOpen(g); load(); }} />;
  if (open) return <GrnView grn={open} onClose={close} />;
  return (
    <div className="space-y-3" data-testid="grn-list">
      <button onClick={() => setOpen("new")} className="flex h-11 items-center gap-2 rounded-xl bg-amber-500 px-4 text-sm font-bold text-slate-950" data-testid="grn-new"><Plus className="h-4 w-4" />New GRN</button>
      {list.map((g) => (
        <button key={g.id} onClick={() => openGrn(g)} className="flex w-full flex-wrap items-center gap-x-3 gap-y-1 rounded-2xl border border-slate-200 bg-white p-4 text-left hover:border-slate-400" data-testid={`grn-row-${g.number}`}>
          <span className="font-mono text-sm font-bold">{g.number}</span>
          <span className="font-semibold text-slate-900">{g.supplier}</span>
          <span className="font-mono text-xs text-slate-500">Inv {g.invoice_no} · {g.invoice_date}</span>
          <span className="ml-auto font-mono text-xs text-slate-500">{g.totals.accepted} accepted</span>
          <StatusPill s={g.status} id={`grn-status-${g.number}`} />
        </button>
      ))}
      {!list.length && <div className="rounded-2xl border border-dashed border-slate-300 p-10 text-center text-sm text-slate-400">No goods received yet</div>}
    </div>
  );
}
